<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M17.5 13h25a1.5 1.5 0 000-3h-25a1.5 1.5 0 000 3zM42.5 22.5h-25a1.5 1.5 0 000 3h25a1.5 1.5 0 000-3zM42.5 35h-25a1.5 1.5 0 000 3h25a1.5 1.5 0 000-3z"/><circle cx="6.5" cy="11.5" r="2.5"/><circle cx="6.5" cy="24" r="2.5"/><circle cx="6.5" cy="36.5" r="2.5"/></svg>